(function () {
  "use strict";
  var URL_ = "https://moskin-leads.187-124-9-109.sslip.io/lead";
  var KEY = "amp_attrib";
  var PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "gclid"];
  var last = new WeakMap();
  var SKIP = /^(form_type|utf8|_token|authenticity.*|id|g-recaptcha.*|.*honeypot.*)$/i;

  var BAD = /^(customer\[|page\[|_keyLabel|hidden-\d+)/;

  function attrib() {
    var s = {};
    try { s = JSON.parse(sessionStorage.getItem(KEY) || "{}") || {}; } catch (e) {}
    try {
      var q = new URLSearchParams(location.search);
      PARAMS.forEach(function (p) {
        var v = q.get(p);
        if (v && !s[p]) s[p] = v;
      });
      sessionStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
    return s;
  }
  try { attrib(); } catch (e) {}

  function clean(k) { return k.replace(/^contact\[/, "").replace(/\]$/, ""); }
  function cut(v) { return String(v).trim().slice(0, 500); }

  function isTarget(form) {
    if (form.closest && form.closest(".globo-formbuilder")) return true;
    if (/globo/i.test((form.className || "") + " " + (form.id || ""))) return true;
    var ft = form.querySelector('input[name="form_type"][value="contact"]');
    if (!ft) return false;
    return !!form.querySelector('input[type="tel"], input[name*="phone" i], input[name*="tel" i], input[name*="телефон" i]');
  }

  function labelOf(el) {
    var c = el.closest(".globo-form-control"), l = c && c.querySelector("label");
    return l ? (l.innerText || "").replace(/[\s*]+$/, "").trim() : "";
  }

  function build(form) {
    var p = {}, extra = {}, cityKey = null, srcField = "", seen = {};
    [].forEach.call(form.elements, function (el) {
      var t = el.type, rawKey = el.name;
      if (!rawKey || el.disabled || /^(button|submit|reset|image|file)$/.test(t)) return;
      if ((t === "checkbox" || t === "radio") && !el.checked) return;
      var key = clean(rawKey);
      if (el.closest(".globo-formbuilder")) {
        var lb = labelOf(el);
        if (t === "tel" || /^phone/i.test(rawKey)) key = "phone";
        else if (/^(name|text(-\d+)?)$/i.test(rawKey) && /ім|name|імя|ПІБ/i.test(lb)) key = "name";
        else if (lb) key = lb;
      }
      seen[key] = 1;
      var v = cut(el.value);
      if (!v || SKIP.test(key) || v.indexOf("{{") > -1 || BAD.test(rawKey) || BAD.test(key)) return;
      if (/^джерело$/i.test(key)) { srcField = v; return; }
      var f = null;
      if (/email|e-mail|пошта/i.test(key)) f = "email";
      else if (/phone|tel|телефон/i.test(key)) f = "phone";
      else if (/name|ім.?я|імя|full/i.test(key)) f = "name";
      else if (/місто|city|ательє|бутік|адреса бутіка/i.test(key)) {
        if (!cityKey || key === "Місто" || (cityKey !== "Місто" && key === "Місто та ательє")) { cityKey = key; p.city = v; }
        else extra[key] = v;
        return;
      }
      else if (/дата|date/i.test(key)) f = "date";
      else if (/body|message|повідомлення|коментар|comment/i.test(key)) f = "message";
      if (f && !p[f]) p[f] = v; else extra[key] = v;
    });
    if (!p.phone && !p.email) return null;
    var path = location.pathname, src;
    if (srcField) src = srcField;
    else if (path.indexOf("zapys-na-prymirku") > -1) src = "Сайт: запис на примірку";
    else if (path.indexOf("indyvidualne-poshyttia") > -1) src = "Сайт: індивідуальне пошиття";
    else if (path.indexOf("/pages/contact") > -1) src = "Сайт: контакти";
    else if (path.indexOf("atelier") > -1 || cityKey === "Місто та ательє" || seen["Місто та ательє"]) src = "Сайт: примірка в ательє";
    else src = "Сайт: форма";
    if (/\/en(\/|$)/.test(path)) src += " (EN)";
    p.form_source = src;
    p.extra = extra;
    p.page_url = location.href;
    var a = attrib();
    PARAMS.forEach(function (k) { if (a[k]) p[k] = a[k]; });
    return p;
  }

  function send(json) {
    var ok = false;
    try {
      if (navigator.sendBeacon) ok = navigator.sendBeacon(URL_, new Blob([json], { type: "text/plain;charset=UTF-8" }));
    } catch (e) {}
    if (!ok) {
      try {
        fetch(URL_, { method: "POST", body: json, keepalive: true, mode: "cors", headers: { "Content-Type": "text/plain;charset=UTF-8" } }).catch(function () {});
      } catch (e) {}
    }
  }

  var PK = "amp_kc_pending", TTL = 10 * 60 * 1000, gPending = null;
  window.__ampKeycrm = { lastPayload: null, sent: 0 };

  function fire(p) {
    window.__ampKeycrm.lastPayload = p;
    window.__ampKeycrm.sent++;
    send(JSON.stringify(p));
  }

  function isGlobo(form) {
    return !!((form.closest && form.closest(".globo-formbuilder")) || /globo/i.test((form.className || "") + " " + (form.id || "")));
  }

  /* 1) submit: only remember the payload, never send here */
  document.addEventListener("submit", function (e) {
    try {
      var form = e.target;
      if (!form || form.nodeType !== 1 || form.tagName !== "FORM" || !isTarget(form)) return;
      var p = build(form);
      if (!p) return;
      if (isGlobo(form)) { gPending = { p: p, t: Date.now() }; return; }
      /* native Shopify contact form: page reloads; keep payload until we see success */
      sessionStorage.setItem(PK, JSON.stringify({ p: p, t: Date.now() }));
    } catch (err) {}
  }, true);

  /* 2) native forms: on the page after the POST, send only if Shopify reports success */
  function navUrl() {
    try { var n = performance.getEntriesByType("navigation")[0]; if (n && n.name) return n.name; } catch (e) {}
    return location.href;
  }
  function checkNative() {
    var raw = null;
    try { raw = sessionStorage.getItem(PK); } catch (e) {}
    if (!raw) return;
    var ok = /[?&]contact_posted=true/.test(navUrl()) || /[?&]contact_posted=true/.test(location.search);
    /* note: form.posted_successfully? is true on plain GETs too, so only the contact_posted=true redirect counts */
    var d = null;
    try { d = JSON.parse(raw); } catch (e) {}
    var fresh = d && d.p && Date.now() - d.t < TTL;
    /* no success marker (form errors, captcha /challenge page, other page): keep it until success or expiry */
    if (!ok && fresh) return;
    try { sessionStorage.removeItem(PK); } catch (e) {}
    if (ok && fresh) fire(d.p);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", checkNative); else checkNative();

  /* 3) Globo: send only when its /send request returns success */
  var GRE = /powerfulform\.com\/api\/front\/form\/\d+\/send|\/api\/front\/form\/\d+\/send/;
  function globoDone(status, body) {
    if (!gPending || Date.now() - gPending.t > 120000) return;
    if (status < 200 || status >= 300) return;
    try {
      var j = JSON.parse(body);
      if (j && (j.success === false || j.success === "false" || j.status === false || j.status === "false" || j.status === "error" || j.errors)) return;
    } catch (e) {}
    var p = gPending.p; gPending = null;
    fire(p);
  }
  try {
    var of = window.fetch;
    if (of) window.fetch = function (input, init) {
      var u = typeof input === "string" ? input : (input && input.url) || "";
      var pr = of.apply(this, arguments);
      if (GRE.test(u)) pr.then(function (r) { try { r.clone().text().then(function (t) { globoDone(r.status, t); }); } catch (e) {} }).catch(function () {});
      return pr;
    };
  } catch (e) {}
  try {
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__ampG = GRE.test(String(u || "")); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x.__ampG) x.addEventListener("loadend", function () { var t = ""; try { t = x.responseText; } catch (e) {} globoDone(x.status, t); });
      return os.apply(this, arguments);
    };
  } catch (e) {}
})();
